import { Environment } from "../environment.interface";

const prodConfig: Environment = {
  production: true,
  app: {
    appBuild: 29,
    applicationId: "673195753",
    appName: "aha-smarttv-ui-prod",
    majorVersion: "0",
    minorVersion: "0",
    patchVersion: "1",
    appVersionId: "673198239",
    asn: "10796",
    asnowner: "Time Warner Cable Internet LLC",
  },
  youbora: {
    accountCode: "firstlight",
  },
  configUrl: "https://config-service-cdn.api.ahacms.firstlight.ai/launch/config",
};

export default prodConfig;
